import React, { useCallback, useMemo, memo } from 'react'
import styled, { css } from 'styled-components'
import { SelectBox } from '@usap/widgets'
import axios from 'axios'
import { BoxNoFocus } from './style/VSLayout.css'
import localConfig from '../../../config/local-config'
import apiConfig from '../../../config/api-config'

const EmptyArray = []

const getYears = async () => {
  try {
    const apiUrl = `${apiConfig.apiURL}/v2/years`
    const response = await axios.get(apiUrl, {
      params: {
        domain: localConfig.hostname,
      },
      headers: {
        apikey: apiConfig.apiKey,
      },
    })

    const responseData = response && response.data
    const years = (responseData.data && responseData.data.years) || []

    return years.map(x => String(x))
  } catch (err) {
    console.error('vs-layout:', err)
  }

  return []
}

const getInitialData = async (key, updateCallback) => {
  const mapping = {
    year: getYears,
  }

  const initialCall = mapping[key]

  if (initialCall) {
    updateCallback(await initialCall())
  } else {
    updateCallback([])
  }
}

const hideOnMobile = css`
  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    display: none;
  }
`

const BoxWithGap = styled.div`
  width: 100%;
  & + & {
    ${props => props.theme.mediaQuery.up('tablet-landscape')} {
      margin-left: ${props => props.theme.global.edgeSize.small};
    }
    ${props => props.theme.mediaQuery.down('tablet-landscape')} {
      margin-top: 10px;
    }
  }
  ${props => props.hideOnMobile && hideOnMobile}
`

const mobileDataTestId = {
  year: 'wom-vehicle-not-selected-drop-down-global',
}

const desktopDataTestId = {
  year: 'desktop-vehicle-not-selected-drop-down-global',
}

const VehicleSelectorOption = ({
  element,
  dropHeight,
  overlay,
  resetDefault,
  onChangeHandler,
  onKeyUp,
  selectBoxWidth,
  selectBoxMinWidth,
  isDesktop,
}) => {
  const {
    key,
    text,
    options = EmptyArray,
    value,
    disabled,
    isMobile,
    open,
  } = element

  const dataTestId = useMemo(() => (isDesktop ? desktopDataTestId[`${key}`] : mobileDataTestId[`${key}`]), [isDesktop, key])
  const selectValue = useMemo(() => (!disabled && value ? value : text), [disabled, value, text])
  const hideSelect = useMemo(() => selectValue.toLowerCase() === key && !isMobile, [selectValue, key, isMobile])
  const loader = useCallback(update => getInitialData(key, update), [key])
  const background = useMemo(() => ({
    color: 'white',
    opacity: disabled ? '0.4' : 1,
  }), [disabled])

  return (
    <BoxWithGap key={key} hideOnMobile={hideSelect}>
      <BoxNoFocus round="5px" background={background} data-testid={dataTestId}>
        <SelectBox
          index={key}
          text={text}
          open={open}
          dropHeight={dropHeight}
          options={options}
          disabled={disabled}
          selectValue={selectValue}
          overlay={overlay}
          resetDefault={resetDefault}
          onChangeHandler={onChangeHandler}
          element={element}
          onKeyUp={onKeyUp}
          selectBoxWidth={selectBoxWidth}
          selectBoxMinWidth={selectBoxMinWidth}
          onOpen={loader}
        />
      </BoxNoFocus>
    </BoxWithGap>
  )
}

export default memo(VehicleSelectorOption)
